module.exports = __webpack_public_path__ + "static/img/4.4f815d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.jpg
// module id = CtaL
// module chunks = 0